// Relación entre asignaciones y actas, compartida por Gestión de Actas y el detalle del acta.
//
// Un acta pertenece a una asignación si:
//   1) está ligada directamente (asignacionId), o
//   2) es histórica y corresponde al mismo equipo y a la misma persona. La persona se reconoce por
//      usuarioId o, cuando el acta histórica solo trae el nombre (usuarioId vacío), por el nombre.
// Un acta histórica de OTRA persona del mismo equipo no cuenta: es de un dueño anterior.

export const normNombre = (s) =>
  String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

export const claveAsignacion = (asignacion) => {
  if (String(asignacion.id).startsWith('mov_')) return asignacion.id;
  return `asig_${asignacion.id}`;
};

const claveActivoUsuario = (activoId, usuarioId) => (activoId && usuarioId ? `av_${activoId}_${usuarioId}` : null);
const claveActivoNombre = (activoId, nombre) => {
  const n = normNombre(nombre);
  return activoId && n ? `an_${activoId}_${n}` : null;
};

const masReciente = (a, b) => !b || new Date(a.fechaFirma || a.fechaCreacion || 0) > new Date(b.fechaFirma || b.fechaCreacion || 0);

/** Agrega un acta al mapa por todas las claves con las que se puede encontrar. */
export const indexarActa = (mapa, acta) => {
  if (acta.asignacionId) {
    mapa[`asig_${acta.asignacionId}`] = acta;
  } else if (acta.movimientoId) {
    mapa[`mov_${acta.movimientoId}`] = acta;
  }
  if (acta.esHistorica && acta.activoId) {
    const claves = [];
    if (acta.usuarioId) claves.push(claveActivoUsuario(acta.activoId, acta.usuarioId));
    claves.push(claveActivoNombre(acta.activoId, acta.usuarioNombre || acta.historico?.usuarioNombre));
    claves.filter(Boolean).forEach((k) => {
      if (masReciente(acta, mapa[k])) mapa[k] = acta;
    });
  }
};

/** Acta de una asignación: la ligada directamente o la histórica del mismo equipo y persona. */
export const buscarActaDeAsignacion = (asignacion, mapa) => {
  const directa = mapa[claveAsignacion(asignacion)];
  if (directa) return directa;
  const activoId = asignacion.activoId ?? asignacion.activo?.id;
  const usuarioId = asignacion.usuarioId ?? asignacion.usuario?.id;
  const porId = claveActivoUsuario(activoId, usuarioId);
  if (porId && mapa[porId]) return mapa[porId];
  const nombre = `${asignacion.usuario?.nombre || ''} ${asignacion.usuario?.apellido || ''}`;
  const porNombre = claveActivoNombre(activoId, nombre);
  return porNombre ? mapa[porNombre] : undefined;
};

/** Para el detalle: elige entre las actas históricas de un equipo la que corresponde a la persona asignada. */
export const elegirHistoricaDeAsignacion = (asignacion, historicas) => {
  const activoId = asignacion?.activoId ?? asignacion?.activo?.id;
  const mapa = {};
  (historicas || []).forEach((a) => indexarActa(mapa, { ...a, esHistorica: true, activoId: a.activoId ?? activoId }));
  return buscarActaDeAsignacion(asignacion, mapa) || null;
};
